"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[597],{

/***/ 51469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sx": function() { return /* binding */ useBreakpointValue; }
/* harmony export */ });
/* unused harmony exports Hide, Show, useBreakpoint, useColorModePreference, useMediaQuery, usePrefersReducedMotion, useQuery */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83904);
/* harmony import */ var _chakra_ui_react_env__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18229);
/* harmony import */ var _chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54302);
// ../../../react-shim.js


// src/media-query.tsx

var getBreakpoint = (theme, value) => {
  var _a;
  return ((_a = theme == null ? void 0 : theme.breakpoints) == null ? void 0 : _a[value]) ?? value;
};
function useQuery(props) {
  const { breakpoint = "", below, above } = props;
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  const bpBelow = getBreakpoint(theme, below);
  const bpAbove = getBreakpoint(theme, above);
  let query = breakpoint;
  if (bpBelow) {
    query = `(max-width: ${bpBelow})`;
  } else if (bpAbove) {
    query = `(min-width: ${bpAbove})`;
  }
  return query;
}

// src/use-media-query.ts


function useMediaQuery(query, options = {}) {
  const { ssr = true, fallback } = options;
  const env = (0,_chakra_ui_react_env__WEBPACK_IMPORTED_MODULE_2__/* .useEnvironment */ .O)();
  const queries = Array.isArray(query) ? query : [query];
  let fallbackValues = Array.isArray(fallback) ? fallback : [fallback];
  fallbackValues = fallbackValues.filter((v) => v != null);
  const [value, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => {
    return queries.map((query2, index) => ({
      media: query2,
      matches: ssr ? !!fallbackValues[index] : env.window.matchMedia(query2).matches
    }));
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setValue(queries.map((query2) => ({
      media: query2,
      matches: env.window.matchMedia(query2).matches
    })));
    const mql = queries.map((query2) => env.window.matchMedia(query2));
    const handler = (evt) => {
      setValue((prev) => {
        return prev.slice().map((item) => {
          if (item.media === evt.media)
            return { ...item, matches: evt.matches };
          return item;
        });
      });
    };
    mql.forEach((mql2) => {
      if (typeof mql2.addListener === "function") {
        mql2.addListener(handler);
      } else {
        mql2.addEventListener("change", handler);
      }
    });
    return () => {
      mql.forEach((mql2) => {
        if (typeof mql2.removeListener === "function") {
          mql2.removeListener(handler);
        } else {
          mql2.removeEventListener("change", handler);
        }
      });
    };
  }, [env.window]);
  return value.map((item) => item.matches);
}

// src/media-query.hook.ts
function usePrefersReducedMotion(options) {
  const [prefersReducedMotion] = useMediaQuery("(prefers-reduced-motion: reduce)", options);
  return prefersReducedMotion;
}
function useColorModePreference(options) {
  const [isLight, isDark] = useMediaQuery(["(prefers-color-scheme: light)", "(prefers-color-scheme: dark)"], options);
  if (isLight)
    return "light";
  if (isDark)
    return "dark";
  return void 0;
}

// src/use-breakpoint.ts


// ../../utilities/shared-utils/src/index.ts
function isObject(value) {
  const type = typeof value;
  return value != null && (type === "object" || type === "function") && !Array.isArray(value);
}

// src/use-breakpoint.ts
function useBreakpoint(arg) {
  var _a;
  const opts = isObject(arg) ? arg : { fallback: arg ?? "base" };
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  const breakpoints = theme.__breakpoints.details.map(({ minMaxQuery, breakpoint }) => ({
    breakpoint,
    query: minMaxQuery.replace("@media screen and ", "")
  }));
  const fallback = breakpoints.map((bp) => bp.breakpoint === opts.fallback);
  const values = useMediaQuery(breakpoints.map((bp) => bp.query), { fallback, ssr: opts.ssr });
  const index = values.findIndex((value) => value == true);
  return ((_a = breakpoints[index]) == null ? void 0 : _a.breakpoint) ?? opts.fallback;
}

// src/use-breakpoint-value.ts



// src/media-query.utils.ts

function getClosestValue(values, breakpoint, breakpoints = _chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__/* .breakpoints */ .AV) {
  let index = Object.keys(values).indexOf(breakpoint);
  if (index !== -1) {
    return values[breakpoint];
  }
  let stopIndex = breakpoints.indexOf(breakpoint);
  while (stopIndex >= 0) {
    const key = breakpoints[stopIndex];
    if (values.hasOwnProperty(key)) {
      index = stopIndex;
      break;
    }
    stopIndex -= 1;
  }
  if (index !== -1) {
    const key = breakpoints[index];
    return values[key];
  }
  return void 0;
}

// src/use-breakpoint-value.ts
function useBreakpointValue(values, arg) {
  var _a;
  const opts = isObject(arg) ? arg : { fallback: arg ?? "base" };
  const breakpoint = useBreakpoint(opts);
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  if (!breakpoint)
    return;
  const breakpoints = Array.from(((_a = theme.__breakpoints) == null ? void 0 : _a.keys) || []);
  const obj = Array.isArray(values) ? Object.fromEntries(Object.entries((0,_chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__/* .arrayToObjectNotation */ .Yq)(values, breakpoints)).map(([key, value]) => [key, value])) : values;
  return getClosestValue(obj, breakpoint, breakpoints);
}

// src/visibility.tsx
function Visibility(props) {
  const { breakpoint, hide, children, ssr } = props;
  const [show] = useMediaQuery(breakpoint, { ssr });
  const isVisible = hide ? !show : show;
  const rendered = isVisible ? children : null;
  return rendered;
}

// src/show.tsx
function Show(props) {
  const { children, ssr } = props;
  const query = useQuery(props);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Visibility, {
    breakpoint: query,
    ssr
  }, children);
}
Show.displayName = "Show";

// src/hide.tsx
function Hide(props) {
  const { children, ssr } = props;
  const query = useQuery(props);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Visibility, {
    breakpoint: query,
    hide: true,
    ssr
  }, children);
}
Hide.displayName = "Hide";



/***/ }),

/***/ 60316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "aG": function() { return /* reexport */ StructuredData_Breadcrumb; },
  "By": function() { return /* reexport */ StructuredData_Faq; },
  "TR": function() { return /* reexport */ StructuredData_Logo; },
  "dc": function() { return /* reexport */ StructuredData_NltOffer; },
  "_6": function() { return /* reexport */ StructuredData_OfferList; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/containers/data/brands.json
var brands = __webpack_require__(11669);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/common/StructuredData/NltOffer.tsx





var NltOffer = function NltOffer(_ref) {
  var offerData = _ref.offerData;
  var data = {
    "@context": "https://schema.org/",
    "@type": "Vehicle",
    "name": "".concat(offerData.vehicle.name, " - Noleggio a Lungo Termine"),
    "image": offerData.images.map(function (image) {
      return image.src;
    }),
    "description": "".concat(offerData.vehicle.name, " a ").concat(offerData.monthlyRate, "\u20AC al mese! Con CarPlanner hai manutenzione, assicurazione, bollo, tassa di propriet\xE0 a molti altri servizi, inclusi in un unico canone mensile."),
    "sku": offerData.code,
    "mpn": offerData.id,
    "fuelType": offerData.vehicle.engine.fuel,
    "brand": {
      "@type": "Brand",
      "name": offerData.vehicle.brand,
      "logo": brands.find(function (brand) {
        return brand.href === offerData.vehicle.brandCode;
      }).image
    },
    "offers": {
      "@type": "Offer",
      "url": "https://www.carplanner.com/noleggio-a-lungo-termine/".concat(offerData.vehicle.brandCode, "/").concat(offerData.vehicle.modelCode, "/").concat(offerData.code),
      "priceCurrency": 'EUR',
      "price": offerData.monthlyRate,
      "itemCondition": 'https://schema.org/NewCondition',
      "availability": 'https://schema.org/LimitedAvailability',
      "seller": {
        '@type': 'Organization',
        "name": "CarPlanner",
        "url": "https://www.carplanner.com/",
        "logo": "https://static1.carplanner.com/logos/carplanner.svg"
      }
    }
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      type: "application/ld+json",
      id: "structuredDataNltOffer",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(data)
      }
    })
  });
};

/* harmony default export */ var StructuredData_NltOffer = (NltOffer);
;// CONCATENATED MODULE: ./src/components/common/StructuredData/Logo.tsx




var Logo = function Logo() {
  var data = {
    "@context": "https://schema.org/",
    "@type": "Organization",
    "name": "Noleggio a Lungo Termine",
    "url": "https://www.carplanner.com/",
    "logo": "https://static1.carplanner.com/logos/carplanner.svg"
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      type: "application/ld+json",
      id: "structuredDataLogo",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(data)
      }
    })
  });
};

/* harmony default export */ var StructuredData_Logo = (Logo);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./server/api/nlt.ts
var nlt = __webpack_require__(27449);
;// CONCATENATED MODULE: ./src/components/common/StructuredData/Faq.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var Faq = function Faq() {
  var _useState = (0,react.useState)([]),
      faqSingleItems = _useState[0],
      setFaqSingleItems = _useState[1];

  (0,react.useEffect)(function () {
    function getFaqs() {
      return _getFaqs.apply(this, arguments);
    }

    function _getFaqs() {
      _getFaqs = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var faqs;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0,nlt/* getFaqAutoCompleteItems */.eF)();

              case 2:
                faqs = _context.sent;
                setFaqSingleItems(faqs.data);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getFaqs.apply(this, arguments);
    }

    if (!faqSingleItems.length) {
      getFaqs();
    }
  });
  var faqItems = {};
  faqSingleItems.forEach(function (faqItem) {
    faqItems[faqItem.uri] = faqItems[faqItem.uri] || [];
    faqItems[faqItem.uri].push(_objectSpread({}, faqItem));
  });
  var data = {
    "@context": "https://schema.org/",
    "@type": "FAQPage",
    "mainEntity": Object.keys(faqItems).map(function (faqUri) {
      return {
        "@type": "Question",
        "url": "https://www.carplanner.com/noleggio-a-lungo-termine/faq/".concat(faqUri),
        "name": faqItems[faqUri][0].title,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": faqItems[faqUri].map(function (faqItem) {
            return "<p><strong>".concat(faqItem.q || '', "</strong> ").concat(faqItem.a || '', "</p>");
          }).join('')
        }
      };
    })
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      type: "application/ld+json",
      id: "structuredDataFaq",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(data)
      }
    })
  });
};

/* harmony default export */ var StructuredData_Faq = (Faq);
;// CONCATENATED MODULE: ./src/components/common/StructuredData/Breadcrumb.tsx




var Breadcrumb = function Breadcrumb(_ref) {
  var breadcrumbData = _ref.breadcrumbData;
  var data = {
    "@context": "https://schema.org/",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbData.map(function (crumbItem, idx) {
      return {
        "@type": "ListItem",
        "position": idx + 1,
        "name": crumbItem.title,
        "item": "https://carplanner.com".concat(crumbItem.href)
      };
    })
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      type: "application/ld+json",
      id: "structuredDataBreadcrumb",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(data)
      }
    })
  });
};

/* harmony default export */ var StructuredData_Breadcrumb = (Breadcrumb);
;// CONCATENATED MODULE: ./src/components/common/StructuredData/OfferList.tsx




var OfferList = function OfferList(_ref) {
  var items = _ref.items;
  var data = {
    "@context": "https://schema.org/",
    "@type": "ItemList",
    "numberOfItems": items.length,
    "itemListElement": items.map(function (item, idx) {
      return {
        "@type": "ListItem",
        "position": idx,
        "url": item
      };
    })
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      type: "application/ld+json",
      id: "structuredDataOfferList",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(data)
      }
    })
  });
};

/* harmony default export */ var StructuredData_OfferList = (OfferList);
;// CONCATENATED MODULE: ./src/components/common/StructuredData/index.ts






/***/ }),

/***/ 70597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14416);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(51469);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(48641);
/* harmony import */ var src_components_NltOffers___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92668);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(18132);
/* harmony import */ var src_redux_nlt_offer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4524);
/* harmony import */ var src_utils_hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4848);
/* harmony import */ var src_components_common__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20213);
/* harmony import */ var src_components_common_StructuredData__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(60316);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);













var Pagination = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(6319), __webpack_require__.e(804), __webpack_require__.e(1937), __webpack_require__.e(1483)]).then(__webpack_require__.bind(__webpack_require__, 81483));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(81483)];
    }
  }
});
var MobileActionBar = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 88124));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(88124)];
    }
  }
});
var HomeOffersList = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(5061), __webpack_require__.e(9594)]).then(__webpack_require__.bind(__webpack_require__, 52711));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(52711)];
    }
  }
});

var LandingBrandNltOffersContainer = function LandingBrandNltOffersContainer(_ref) {
  var slug = _ref.slug,
      page = _ref.page;

  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_9__/* .useTranslation */ .$)(),
      t = _useTranslation.t;

  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
  var isMobile = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .useBreakpointValue */ .Sx)({
    base: true,
    md: false
  });
  var filterMenuIsOpen = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function (state) {
    return state.nlt.filterMenuIsOpen;
  });
  var offers = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function (state) {
    return state.nlt.filteredOffers;
  });
  var otherOffers = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function (state) {
    return state.nlt.offers;
  });

  var onPaginatorClickHandler = function onPaginatorClickHandler(page) {
    return dispatch((0,src_redux_nlt_offer__WEBPACK_IMPORTED_MODULE_4__/* .setListingPage */ .Dx)(page));
  };

  (0,src_utils_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useBackButton */ .Kx)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Box */ .xu, {
    px: "l",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(src_components_common__WEBPACK_IMPORTED_MODULE_6__/* .LinkRel */ .Mu, {
      rel: "canonical",
      href: "https://www.carplanner.com/noleggio-a-lungo-termine/".concat(slug).concat(page && page > 1 ? "?pagina=".concat(page) : '')
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(src_components_common_StructuredData__WEBPACK_IMPORTED_MODULE_7__/* .OfferList */ ._6, {
      items: offers.items.map(function (item) {
        return ['https://carplanner.com/noleggio-a-lungo-termine/', item.brandCode, '/', item.modelCode, '/', item.code, '?deposit=', item.deposit, '&contractLength=', item.contractLength, '&annualMileage=', item.annualMileage].join('');
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(src_components_NltOffers___WEBPACK_IMPORTED_MODULE_3__/* .ActionBar */ .ol, {
      offersCount: offers.items.length
    }), offers.items && offers.items.length ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Grid */ .rj, {
        templateColumns: {
          md: "repeat(".concat(filterMenuIsOpen ? 2 : 3, ", 1fr)"),
          lg: "repeat(".concat(filterMenuIsOpen ? 3 : 4, ", 1fr)")
        },
        gap: 6,
        pt: "l",
        pb: "24px",
        children: [offers.items.map(function (item) {
          return item.code === 'auto-promo' ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .GridItem */ .P4, {
            display: "inline-grid",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(src_components_NltOffers___WEBPACK_IMPORTED_MODULE_3__/* .AutoPromo */ .b9, {
              item: item
            })
          }, "".concat(item.code, "- ").concat(item.title, " ")) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .GridItem */ .P4, {
            display: "inline-grid",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(src_components_NltOffers___WEBPACK_IMPORTED_MODULE_3__/* .Offer */ .Vw, {
              item: item
            })
          }, item.code);
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .GridItem */ .P4, {
          colSpan: {
            md: filterMenuIsOpen ? 2 : 3,
            lg: filterMenuIsOpen ? 3 : 4
          },
          mt: "-2",
          textAlign: "left",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(Pagination, {
            currentPage: offers.currentPage,
            perPage: offers.pageSize,
            total: offers.results,
            onClick: onPaginatorClickHandler
          })
        }, "load-more")]
      }), isMobile && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(MobileActionBar, {})]
    }) : isMobile ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Box */ .xu, {
      pb: "24px",
      px: "l",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Heading */ .X6, {
        as: "h3",
        px: "l",
        pt: "l",
        fontSize: "2xl",
        fontFamily: "Montserrat-SemiBold",
        children: t('nltPage:notFound')
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(HomeOffersList, {
        action: t('indexPage:nlt_offers.action'),
        alt: t('indexPage:nlt_offers.alt'),
        bgColor: "baseNeutral.100",
        href: "/noleggio-a-lungo-termine",
        offers: otherOffers,
        numPerView: filterMenuIsOpen ? 3 : 4
      })]
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Grid */ .rj, {
      templateColumns: {
        md: "repeat(".concat(filterMenuIsOpen ? 2 : 3, ", 1fr)"),
        lg: "repeat(".concat(filterMenuIsOpen ? 3 : 4, ", 1fr)")
      },
      gap: 6,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .GridItem */ .P4, {
        colSpan: {
          md: filterMenuIsOpen ? 2 : 3,
          lg: filterMenuIsOpen ? 3 : 4
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Heading */ .X6, {
          as: "h3",
          fontSize: "2xl",
          fontFamily: "Montserrat-SemiBold",
          children: t('nltPage:notFound')
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .GridItem */ .P4, {
        colSpan: {
          md: filterMenuIsOpen ? 2 : 3,
          lg: filterMenuIsOpen ? 3 : 4
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(HomeOffersList, {
          w: "100%",
          action: t('indexPage:nlt_offers.action'),
          alt: t('indexPage:nlt_offers.alt'),
          bgColor: "baseNeutral.100",
          href: "/noleggio-a-lungo-termine",
          offers: otherOffers,
          numPerView: filterMenuIsOpen ? 3 : 4,
          paddingLeft: "0px",
          paddingRight: "0px"
        })
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (LandingBrandNltOffersContainer);

/***/ }),

/***/ 4848:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kx": function() { return /* binding */ useBackButton; },
/* harmony export */   "rS": function() { return /* binding */ useTracking; }
/* harmony export */ });
/* unused harmony export useQuerystringToFilterOffers */
/* harmony import */ var _codebuild_output_src3615454741_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _codebuild_output_src3615454741_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(16835);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14416);
/* harmony import */ var react_cookie__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70461);
/* harmony import */ var query_string_manager__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31086);
/* harmony import */ var query_string_manager__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(query_string_manager__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var src_redux_nlt_offer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4524);
/* harmony import */ var src_redux_sell_offer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7232);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src3615454741_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var useQuerystringToFilterOffers = function useQuerystringToFilterOffers(domain) {
  var dispatch = useDispatch();
  var performSearchOffers = domain === 'nlt' ? nltPerformSearchOffers : sellPerformSearchOffers;
  useEffect(function () {
    var qs = queryStringManager.read().get();

    if (Object.entries(qs).length > 0) {
      dispatch(performSearchOffers());
    }
  }, []);
};
var useBackButton = function useBackButton() {
  var onPopState = function onPopState() {
    if (query_string_manager__WEBPACK_IMPORTED_MODULE_4___default().read().get()) {
      location.reload();
    }
  };

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    window.addEventListener('popstate', onPopState);
    return function () {
      window.removeEventListener('popstate', onPopState);
    };
  });
};
var useTracking = function useTracking() {
  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)(),
      query = _useRouter.query;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}),
      validQuery = _useState[0],
      setValidQuery = _useState[1];

  var _useCookies = (0,react_cookie__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(['CP_TRACKER']),
      _useCookies2 = (0,_codebuild_output_src3615454741_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_useCookies, 3),
      allCookies = _useCookies2[0],
      setCookie = _useCookies2[1],
      removeCookie = _useCookies2[2];

  var path = '/';
  var today = new Date();
  var validity = parseInt("15");
  var expires = new Date(today.setDate(today.getDate() + validity));
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    setValidQuery(query);
  }, [query]);

  var trackingData = function trackingData() {
    return allCookies['CP_TRACKER'];
  };

  var setTracking = function setTracking() {
    var _query$validQuery = _objectSpread(_objectSpread({}, query), validQuery),
        _query$validQuery$utm = _query$validQuery.utm_source,
        source = _query$validQuery$utm === void 0 ? null : _query$validQuery$utm,
        _query$validQuery$utm2 = _query$validQuery.utm_medium,
        medium = _query$validQuery$utm2 === void 0 ? null : _query$validQuery$utm2,
        _query$validQuery$utm3 = _query$validQuery.utm_ref,
        referrer = _query$validQuery$utm3 === void 0 ? null : _query$validQuery$utm3,
        _query$validQuery$utm4 = _query$validQuery.utm_campaign,
        campaign = _query$validQuery$utm4 === void 0 ? null : _query$validQuery$utm4,
        _query$validQuery$utm5 = _query$validQuery.utm_campaign_date,
        campaign_date = _query$validQuery$utm5 === void 0 ? null : _query$validQuery$utm5;

    if ((source || medium || referrer) && (typeof allCookies['CP_TRACKER'] === 'undefined' || !allCookies['CP_TRACKER'])) {
      setCookie('CP_TRACKER', {
        source: source,
        referrer: referrer,
        medium: medium,
        campaign: campaign,
        campaign_date: campaign_date
      }, {
        path: path,
        expires: expires
      });
    }
  };

  var removeTracking = function removeTracking() {
    return removeCookie('CP_TRACKER');
  };

  return [setTracking, removeTracking, trackingData];
};

/***/ }),

/***/ 70461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useCookies; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/cookie/index.js
var cookie = __webpack_require__(76489);
;// CONCATENATED MODULE: ./node_modules/universal-cookie/es6/utils.js

function hasDocumentCookie() {
    // Can we get/set cookies on document.cookie?
    return typeof document === 'object' && typeof document.cookie === 'string';
}
function cleanCookies() {
    document.cookie.split(';').forEach(function (c) {
        document.cookie = c
            .replace(/^ +/, '')
            .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    });
}
function parseCookies(cookies, options) {
    if (typeof cookies === 'string') {
        return cookie.parse(cookies, options);
    }
    else if (typeof cookies === 'object' && cookies !== null) {
        return cookies;
    }
    else {
        return {};
    }
}
function isParsingCookie(value, doNotParse) {
    if (typeof doNotParse === 'undefined') {
        // We guess if the cookie start with { or [, it has been serialized
        doNotParse =
            !value || (value[0] !== '{' && value[0] !== '[' && value[0] !== '"');
    }
    return !doNotParse;
}
function readCookie(value, options) {
    if (options === void 0) { options = {}; }
    var cleanValue = cleanupCookieValue(value);
    if (isParsingCookie(cleanValue, options.doNotParse)) {
        try {
            return JSON.parse(cleanValue);
        }
        catch (e) {
            // At least we tried
        }
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === 'j' && value[1] === ':') {
        return value.substr(2);
    }
    return value;
}

;// CONCATENATED MODULE: ./node_modules/universal-cookie/es6/Cookies.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


var Cookies = /** @class */ (function () {
    function Cookies(cookies, options) {
        var _this = this;
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.cookies = parseCookies(cookies, options);
        new Promise(function () {
            _this.HAS_DOCUMENT_COOKIE = hasDocumentCookie();
        }).catch(function () { });
    }
    Cookies.prototype._updateBrowserValues = function (parseOptions) {
        if (!this.HAS_DOCUMENT_COOKIE) {
            return;
        }
        this.cookies = cookie.parse(document.cookie, parseOptions);
    };
    Cookies.prototype._emitChange = function (params) {
        for (var i = 0; i < this.changeListeners.length; ++i) {
            this.changeListeners[i](params);
        }
    };
    Cookies.prototype.get = function (name, options, parseOptions) {
        if (options === void 0) { options = {}; }
        this._updateBrowserValues(parseOptions);
        return readCookie(this.cookies[name], options);
    };
    Cookies.prototype.getAll = function (options, parseOptions) {
        if (options === void 0) { options = {}; }
        this._updateBrowserValues(parseOptions);
        var result = {};
        for (var name_1 in this.cookies) {
            result[name_1] = readCookie(this.cookies[name_1], options);
        }
        return result;
    };
    Cookies.prototype.set = function (name, value, options) {
        var _a;
        if (typeof value === 'object') {
            value = JSON.stringify(value);
        }
        this.cookies = __assign(__assign({}, this.cookies), (_a = {}, _a[name] = value, _a));
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = cookie.serialize(name, value, options);
        }
        this._emitChange({ name: name, value: value, options: options });
    };
    Cookies.prototype.remove = function (name, options) {
        var finalOptions = (options = __assign(__assign({}, options), { expires: new Date(1970, 1, 1, 0, 0, 1), maxAge: 0 }));
        this.cookies = __assign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = cookie.serialize(name, '', finalOptions);
        }
        this._emitChange({ name: name, value: undefined, options: options });
    };
    Cookies.prototype.addChangeListener = function (callback) {
        this.changeListeners.push(callback);
    };
    Cookies.prototype.removeChangeListener = function (callback) {
        var idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) {
            this.changeListeners.splice(idx, 1);
        }
    };
    return Cookies;
}());
/* harmony default export */ var es6_Cookies = (Cookies);

;// CONCATENATED MODULE: ./node_modules/universal-cookie/es6/index.js

/* harmony default export */ var es6 = (es6_Cookies);

;// CONCATENATED MODULE: ./node_modules/react-cookie/es6/Cookies.js

/* harmony default export */ var react_cookie_es6_Cookies = (es6);

;// CONCATENATED MODULE: ./node_modules/react-cookie/es6/CookiesContext.js


var CookiesContext = react.createContext(new react_cookie_es6_Cookies());
var Provider = CookiesContext.Provider, Consumer = CookiesContext.Consumer;
/* harmony default export */ var es6_CookiesContext = (CookiesContext);

;// CONCATENATED MODULE: ./node_modules/react-cookie/es6/utils.js
function isInBrowser() {
    return (typeof window !== 'undefined' &&
        typeof window.document !== 'undefined' &&
        typeof window.document.createElement !== 'undefined');
}

;// CONCATENATED MODULE: ./node_modules/react-cookie/es6/useCookies.js



function useCookies(dependencies) {
    var cookies = (0,react.useContext)(es6_CookiesContext);
    if (!cookies) {
        throw new Error('Missing <CookiesProvider>');
    }
    var initialCookies = cookies.getAll();
    var _a = (0,react.useState)(initialCookies), allCookies = _a[0], setCookies = _a[1];
    var previousCookiesRef = (0,react.useRef)(allCookies);
    if (isInBrowser()) {
        (0,react.useLayoutEffect)(function () {
            function onChange() {
                var newCookies = cookies.getAll();
                if (shouldUpdate(dependencies || null, newCookies, previousCookiesRef.current)) {
                    setCookies(newCookies);
                }
                previousCookiesRef.current = newCookies;
            }
            cookies.addChangeListener(onChange);
            return function () {
                cookies.removeChangeListener(onChange);
            };
        }, [cookies]);
    }
    var setCookie = (0,react.useMemo)(function () { return cookies.set.bind(cookies); }, [cookies]);
    var removeCookie = (0,react.useMemo)(function () { return cookies.remove.bind(cookies); }, [cookies]);
    return [allCookies, setCookie, removeCookie];
}
function shouldUpdate(dependencies, newCookies, oldCookies) {
    if (!dependencies) {
        return true;
    }
    for (var _i = 0, dependencies_1 = dependencies; _i < dependencies_1.length; _i++) {
        var dependency = dependencies_1[_i];
        if (newCookies[dependency] !== oldCookies[dependency]) {
            return true;
        }
    }
    return false;
}


/***/ }),

/***/ 11669:
/***/ (function(module) {

module.exports = JSON.parse('[{"href":"alfa-romeo","image":"https://static1.carplanner.com/cars/brands/alfa-romeo.svg","name":"Alfa Romeo","slug":"ALF"},{"href":"abarth","image":"https://static1.carplanner.com/cars/brands/abarth.svg","name":"Abarth","slug":"ABA"},{"href":"aston-martin","image":"https://static1.carplanner.com/cars/brands/aston-martin.svg","name":"Aston Martin","slug":"AST"},{"href":"audi","image":"https://static1.carplanner.com/cars/brands/audi.svg","name":"Audi","slug":"AUD"},{"href":"bentley","image":"https://static1.carplanner.com/cars/brands/bentley.svg","name":"Bentley","slug":"BEN"},{"href":"bmw","image":"https://static1.carplanner.com/cars/brands/bmw.svg","name":"BMW","slug":"BMW"},{"href":"cadillac","image":"https://static1.carplanner.com/cars/brands/cadillac.svg","name":"Cadillac","slug":"CAD"},{"href":"chevrolet","image":"https://static1.carplanner.com/cars/brands/chevrolet.svg","name":"Chevrolet","slug":"CHC"},{"href":"chrysler","image":"https://static1.carplanner.com/cars/brands/chrysler.svg","name":"Chrysler","slug":"CHR"},{"href":"citroen","image":"https://static1.carplanner.com/cars/brands/citroen.svg","name":"Citroen","slug":"CIT"},{"href":"cupra","image":"https://static1.carplanner.com/cars/brands/cupra.svg","name":"Cupra","slug":"CUP"},{"href":"dacia","image":"https://static1.carplanner.com/cars/brands/dacia.svg","name":"Dacia","slug":"DAC"},{"href":"dr","image":"https://static1.carplanner.com/cars/brands/dr.svg","name":"DR","slug":"DRM"},{"href":"ds","image":"https://static1.carplanner.com/cars/brands/ds.svg","name":"DS","slug":"DSA"},{"href":"ferrari","image":"https://static1.carplanner.com/cars/brands/ferrari.svg","name":"Ferrari","slug":"FER"},{"href":"fiat","image":"https://static1.carplanner.com/cars/brands/fiat.svg","name":"Fiat","slug":"FIA"},{"href":"ford","image":"https://static1.carplanner.com/cars/brands/ford.svg","name":"Ford","slug":"FOR"},{"href":"honda","image":"https://static1.carplanner.com/cars/brands/honda.svg","name":"Honda","slug":"HON"},{"href":"hyundai","image":"https://static1.carplanner.com/cars/brands/hyundai.svg","name":"Hyundai","slug":"HYU"},{"href":"infiniti","image":"https://static1.carplanner.com/cars/brands/infiniti.svg","name":"Infiniti","slug":"INF"},{"href":"jaguar","image":"https://static1.carplanner.com/cars/brands/jaguar.svg","name":"Jaguar","slug":"JAG"},{"href":"jeep","image":"https://static1.carplanner.com/cars/brands/jeep.svg","name":"Jeep","slug":"JEE"},{"href":"kia","image":"https://static1.carplanner.com/cars/brands/kia.svg","name":"Kia","slug":"KIA"},{"href":"lamborghini","image":"https://static1.carplanner.com/cars/brands/lamborghini.svg","name":"Lamborghini","slug":"LAM"},{"href":"lancia","image":"https://static1.carplanner.com/cars/brands/lancia.svg","name":"Lancia","slug":"LAN"},{"href":"land-rover","image":"https://static1.carplanner.com/cars/brands/land-rover.svg","name":"Land Rover","slug":"LND"},{"href":"lexus","image":"https://static1.carplanner.com/cars/brands/lexus.svg","name":"Lexus","slug":"LEX"},{"href":"lotus","image":"https://static1.carplanner.com/cars/brands/lotus.svg","name":"Lotus","slug":"LOT"},{"href":"mahindra","image":"https://static1.carplanner.com/cars/brands/mahindra.svg","name":"Mahindra","slug":"MAH"},{"href":"maserati","image":"https://static1.carplanner.com/cars/brands/maserati.svg","name":"Maserati","slug":"MAS"},{"href":"mazda","image":"https://static1.carplanner.com/cars/brands/mazda.svg","name":"Mazda","slug":"MAZ"},{"href":"mclaren","image":"https://static1.carplanner.com/cars/brands/mclaren.svg","name":"McLaren","slug":"MCL"},{"href":"mercedes","image":"https://static1.carplanner.com/cars/brands/mercedes.svg","name":"Mercedes-Benz","slug":"MER"},{"href":"mg","image":"https://static1.carplanner.com/cars/brands/mg.svg","name":"MG","slug":"MGG"},{"href":"mini","image":"https://static1.carplanner.com/cars/brands/mini.svg","name":"Mini","slug":"MIN"},{"href":"mitsubishi","image":"https://static1.carplanner.com/cars/brands/mitsubishi.svg","name":"Mitsubishi","slug":"MIT"},{"href":"nissan","image":"https://static1.carplanner.com/cars/brands/nissan.svg","name":"Nissan","slug":"NIS"},{"href":"opel","image":"https://static1.carplanner.com/cars/brands/opel.svg","name":"Opel","slug":"OPE"},{"href":"peugeot","image":"https://static1.carplanner.com/cars/brands/peugeot.svg","name":"Peugeot","slug":"PEU"},{"href":"porsche","image":"https://static1.carplanner.com/cars/brands/porsche.svg","name":"Porsche","slug":"POR"},{"href":"renault","image":"https://static1.carplanner.com/cars/brands/renault.svg","name":"Renault","slug":"REN"},{"href":"rolls-royce","image":"https://static1.carplanner.com/cars/brands/rolls-royce.svg","name":"Rolls-Royce","slug":"ROL"},{"href":"seat","image":"https://static1.carplanner.com/cars/brands/seat.svg","name":"Seat","slug":"SEA"},{"href":"skoda","image":"https://static1.carplanner.com/cars/brands/skoda.svg","name":"Skoda","slug":"SKO"},{"href":"smart","image":"https://static1.carplanner.com/cars/brands/smart.svg","name":"Smart","slug":"SMA"},{"href":"ssangyong","image":"https://static1.carplanner.com/cars/brands/ssangyong.svg","name":"Ssangyong","slug":"SAN"},{"href":"subaru","image":"https://static1.carplanner.com/cars/brands/subaru.svg","name":"Subaru","slug":"SUB"},{"href":"suzuki","image":"https://static1.carplanner.com/cars/brands/suzuki.svg","name":"Suzuki","slug":"SUZ"},{"href":"tesla","image":"https://static1.carplanner.com/cars/brands/tesla.svg","name":"Tesla","slug":"TES"},{"href":"toyota","image":"https://static1.carplanner.com/cars/brands/toyota.svg","name":"Toyota","slug":"TOY"},{"href":"volkswagen","image":"https://static1.carplanner.com/cars/brands/volkswagen.svg","name":"Volkswagen","slug":"VLK"},{"href":"volvo","image":"https://static1.carplanner.com/cars/brands/volvo.svg","name":"Volvo","slug":"VOL"}]');

/***/ })

}]);